export const ODataType = {
  meteredDataLock: 'MeteredDataLock',
  meteredDataNotCreated: 'MeteredDataNotCreated',
  newMeteringPointsWithSupplier: 'NewMeteringPointsWithSupplier',
  queryMeteredData: 'QueryMeteredData',
  // Service Requests
  disconnected: 'Disconnected',
  connected: 'Connected',
  closeDown: 'CloseDown',
  disconnectDueToEndOfSupply: 'DisconnectDueToEndOfSupply',
  meterControl: 'ActiveServiceRequest',
  deviatingMeters: 'DeviatingMeters',
  exceedingPowerLimits: 'ExceedingPowerLimits',
  usedVerificationMeterReadings: 'UsedVerificationMeterReadings',
  meteringPointQuadrantMismatch: 'MeteringPointQuadrantMismatch',
  // Settlement
  queryAggregatedMeteredData: 'QueryAggregatedMeteredData',
  queryAggregatedWholesale: 'QueryAggregatedWholesale',
  queryAggregatedBillingInformation: 'QueryAggregatedBillingInformation',
}
